<script>
	import { onDestroy } from 'svelte';
	import { fly } from 'svelte/transition';
	import { cubicOut } from 'svelte/easing';

	import { db } from '../services/firebase-service';

	import Icons from '../components/icons.svelte';

	import { STATUSES, TEAMS, ACTIONS } from '../utils/constants';

	export let team;

	export let id;
	export let isDummy = false;
	export let name;
	export let isTurn;
	export let isGiver;
	export let isCurrent;
	export let isReadyToPlay;

	let wins = 0;
	let losses = 0;
	let unPlayersMetadata = !isDummy && db.collection('playersMetadata').doc(id).onSnapshot(snap => {
		const d = snap.data();
		if (!d) {
			wins = 0;
			losses = 0;
		}
		else {
			wins = d.wins || 0;
			losses = d.losses || 0;
		}
	});

	const transitionConfig = {
		duration: 600,
		easing: cubicOut
	};

	if (isDummy) {
		transitionConfig.duration = 0;
	}
	else if (team === TEAMS.one) {
		transitionConfig.x = -500;
	}
	else {
		transitionConfig.x = 500;
	}

	onDestroy(() => {
		unPlayersMetadata && unPlayersMetadata();
	});
</script>

<span
	class={`team-item ${team}`}
	class:turn={isTurn}
	class:giver={isGiver}
	class:current-player={isCurrent}
	class:dummy={isDummy}
	class:no-record={!wins && !losses}
	title="{name} has {wins} wins and {losses} losses"
	transition:fly|local={transitionConfig}
>
	{#if name}
		{name}
	{:else}
		(open)
	{/if}

	{#if isReadyToPlay}
		<Icons
			name="play"
			size="1em"
			animateDraw="true"
			strokeColor="#ffffff"
			fillColor="#18d72e" />
	{/if}

	{#if wins || losses}
		<span class="wins-losses">{wins}-{losses}</span>
	{/if}
</span>

<style lang="less">
	@import "../variables.less";

	.team-item {
		display: inline-block;
		max-width: 23vmin;
		margin: 0.25em;
		padding: 0.5em 1.5em;
		font-size: 1.5em;
		vertical-align: middle;
		text-align: center;
		color: white;
		background: rgba(255, 255, 255, 0.6);
		background: linear-gradient(90deg,  rgba(125,0,100,1) 0%, rgba(255,0,204,1) 80%);
		border: 0.3vmin solid #e0e0e0;
		border-radius: 5vmin;

		@media (@aspect-ratio) {
			font-size: 2em;
		}

		&.one {
			background: linear-gradient(90deg, rgba(30,130,255,1) 0%, rgba(30,100,225,1) 50%);
			&.current-player {
				box-shadow: -1vmin 0 1.5vmin rgba(255, 255, 255, 0.6);
			}
		}

		&.current-player {
			color: yellow;
		}

		&.turn {
			border-color: white;
			animation: cycle-color 1s infinite;
			animation-timing-function: ease-in;
		}

		&.dummy {
			background: #636363;
		}

		&.no-record {
			line-height: 1.8em;
		}

		@keyframes cycle-color {
			50% {
				background: transparent;
			}
		}

		@keyframes cycle-border-color {
			50% {
				color: #18d72e;
				border-color: fade(#18d72e, 80%);
			}
		}

		.wins-losses {display:block;
			margin-top: 0.1em;
			font-size: 0.7em;
		}

		:global(.icon) {
			position: relative;
			display: inline-block;
			vertical-align: middle;

			&.play {
				position: absolute;
				top: 50%;
				right: 0.2em;
    			margin-top: -0.6em;
			}
		}
	}
</style>